/**
 * Permission constants for role management.
 * Extracted to avoid circular dependencies between firebase.ts and screen files.
 */

export const ALL_PERMISSIONS: string[] = [
  'NewSale',
  'applyDiscount',
  'newSaleWithoutShift',
  'sellCustomProducts',
  'newSaleSettings',
  'sellOutOfStockProducts',
  'SalesHistory',
  'deleteSale',
  'Supplies',
  'deleteSupply',
  'WriteOffs',
  'deleteWriteOff',
  'Spendings',
  'deleteSpending',
  'viewAdminSpendingCategories',
  'Revisions',
  'deleteRevision',
  'Manufactures',
  'deleteManufacture',
  'Transfers',
  'deleteTransfer',
  'ComplexSales',
  'deleteComplexSale',
  'editComplexSaleTemplates',
  'Payments',
  'Products',
  'deleteProduct',
  'viewInactiveProducts',
  'ProductStocks',
  'Clients',
  'ClientDetail',
  'deleteClient',
  'MarketingLists',
  'PrintStickers',
  'Updates',
  'ClientOrders',
  'Checklist',
  'editChecklistItems',
  'Shift',
  'changeOthersWorkingHours',
  'editShiftStats',
  'Salary',
  'viewOthersWorkingHours',
  'Stats',
  'mainScreenStats',
  'Settings',
  'editProductCategories',
  'editSuppliers',
  'editSettings',
  'editUsers',
  'viewOtherStores',
  'changeStore',
  'billing',
  'exportImport',
]
